import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { reactionSenderLabel } from "./voFloorLiving";

/**
 * Reações e chegadas que atravessam a cena do piso.
 */
export default function VoFloorReactions({ reactions = [], arrivals = [], banners = [] }) {
  if (!reactions.length && !arrivals.length && !banners.length) return null;
  return (
    <Box
      data-vo-floor-reactions="1"
      sx={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        zIndex: 6,
        overflow: "hidden",
      }}
    >
      {banners.map((item) => (
        <Chip
          key={item.id}
          label={item.text}
          sx={{
            position: "absolute",
            left: "50%",
            top: { xs: "36%", md: "40%" },
            transform: "translateX(-50%)",
            fontWeight: 700,
            bgcolor: "rgba(32,33,36,0.88)",
            color: "#f8f4ee",
            border: "1px solid rgba(255,255,255,0.16)",
            animation: "voArriveIn 2.6s ease both",
            "@keyframes voArriveIn": {
              "0%": { opacity: 0, transform: "translate(-50%, -8px)" },
              "12%": { opacity: 1, transform: "translate(-50%, 0)" },
              "80%": { opacity: 1 },
              "100%": { opacity: 0, transform: "translate(-50%, -6px)" },
            },
          }}
        />
      ))}
      {arrivals.map((item) => (
        <Chip
          key={item.id}
          label={`${item.name} chegou`}
          sx={{
            position: "absolute",
            left: "50%",
            top: { xs: "36%", md: "40%" },
            transform: "translateX(-50%)",
            fontWeight: 700,
            bgcolor: "rgba(32,33,36,0.88)",
            color: "#f8f4ee",
            border: "1px solid rgba(255,255,255,0.16)",
            animation: "voArriveIn 2.6s ease both",
            "@keyframes voArriveIn": {
              "0%": { opacity: 0, transform: "translate(-50%, -8px)" },
              "12%": { opacity: 1, transform: "translate(-50%, 0)" },
              "80%": { opacity: 1 },
              "100%": { opacity: 0, transform: "translate(-50%, -6px)" },
            },
          }}
        />
      ))}
      {reactions.map((item) => {
        const who = reactionSenderLabel(item.fromName);
        return (
          <Box
            key={item.id}
            data-vo-reaction-from={who}
            data-vo-reaction-fading={item.fading ? "1" : "0"}
            aria-label={`${who} reagiu com ${item.emoji}`}
            sx={{
              position: "absolute",
              left: `${item.x}%`,
              bottom: `${item.y}%`,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 0.35,
              animation: item.fading
                ? "voReactOut 1.6s ease-in both"
                : "voReactIn 0.45s ease-out both",
              filter: "drop-shadow(0 6px 10px rgba(0,0,0,0.35))",
              "@keyframes voReactIn": {
                "0%": { opacity: 0, transform: "translateY(12px) scale(0.7)" },
                "100%": { opacity: 1, transform: "translateY(0) scale(1)" },
              },
              "@keyframes voReactOut": {
                "0%": { opacity: 1, transform: "translateY(0) scale(1)" },
                "100%": { opacity: 0, transform: "translateY(-28px) scale(1.06)" },
              },
            }}
          >
            <Typography
              aria-hidden
              sx={{
                fontSize: { xs: "1.8rem", md: "2.3rem" },
                lineHeight: 1,
              }}
            >
              {item.emoji}
            </Typography>
            <Typography
              sx={{
                px: 0.7,
                py: 0.15,
                borderRadius: 999,
                bgcolor: "rgba(24,18,14,0.78)",
                border: "1px solid rgba(255,255,255,0.16)",
                color: "#f8f4ee",
                fontSize: "0.68rem",
                fontWeight: 800,
                lineHeight: 1.2,
                letterSpacing: "0.01em",
                wordSpacing: "0.08em",
                whiteSpace: "nowrap",
                maxWidth: 120,
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {who}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
